import { Grid, Stack } from "@mui/material";
import {
  styled
} from "@mui/material/styles";
import {
  CardTabsAttachment,
  CardTabsLink
} from "../../components";
import type { Tool, UsefulLink } from "../../types";

export function CardLinks({
  cardTabsLinks=[],
  cardTabsTools=[],
  disabled,
  showDescription = false
} : {
  cardTabsLinks?: UsefulLink[]
  cardTabsTools?: Tool[],
  disabled: boolean
  showDescription?: boolean
}) {

  const resourcesList = () => {
    let linkList: JSX.Element[] = [];
    let downloadList: JSX.Element[] = [];

    if(cardTabsLinks?.length > 0){
      linkList = cardTabsLinks.map((card, inx: number) => {
        return (
          <CardTabsLink
            key={ `card-links-${inx.toString()}` }
            disabled={ disabled }
            description={ card.description }
            showDescription={ showDescription }
            url_label={ card.url_label }
            url={ card.url }
          />
        );
      });
    }

    if (cardTabsTools.length > 0){
      downloadList = cardTabsTools.map((card, idx: number) => {
        return (
          <CardTabsAttachment
            key={ `card-attachment-${idx.toString()}` }
            disabled={ disabled }
            dimension={ card.dimension }
            id={ card.id }
            name={ card.name }
            shortDescription={ card.shortDescription }
            showDescription={ showDescription }
          />
        );
      });
    }

    return [...linkList ?? [], ...downloadList ?? []]; 
  };

  return (
    <Grid
      id="card-links-container"
      data-testid="card-links-container"
      gap={ "0.5rem" }
      display={ "flex" }
      flexWrap={ "wrap" }
      width={ "100%" }
    >
      {
        (cardTabsLinks?.length > 0 || cardTabsTools.length > 0) ? (
          <ResourcesList
            key={ "explore-resources-list" }
            data-testid="card-links-resources-list"
          >
            { resourcesList() }
          </ResourcesList>
        ) : null
      }
    </Grid>
  );
}


const ResourcesList = styled(Stack)(()=> ({
  flexDirection: "row",
  flexWrap: "wrap",
  height: "fit-content",
  gap: "0.5rem"
}));
